import React, { useState  } from 'react'
import './payment.style.scss'
import InputGroup from './InputGroup'
import { FaArrowCircleRight , FaArrowCircleLeft  } from "react-icons/fa";
import Minicart from '../minicart/Minicart'
import {cartSliceActions} from '../../redux/cardSlice'
import { currencyFormater } from '../../utils/helpers'
import { shippingSliceActions } from '../../redux/shippingDetailsSlice'
import { useSelector , useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom';
const Payment = () => {
    const firstName = useSelector((state)=> state.shipping.firstName)
    const lastName = useSelector((state)=> state.shipping.lastName)
    const city = useSelector((state)=> state.shipping.city)
    const adress = useSelector((state)=> state.shipping.adress)
    const postalCode = useSelector((state)=> state.shipping.postalCode)
    const email = useSelector((state)=> state.shipping.email)
    const country = useSelector((state)=> state.shipping.country)
    const phoneNumber = useSelector((state)=> state.shipping.phoneNumber)
    const cardHolderName = useSelector((state)=> state.shipping.cardHolderName)
    const cardNumber = useSelector((state)=> state.shipping.cardNumber)
    const expire = useSelector((state)=> state.shipping.expire)
    const ccv = useSelector((state)=> state.shipping.ccv)
    //
    const shippingFee = useSelector((state)=>state.cart.shipping_fee)
    const totalAmount = useSelector((state)=>state.cart.total_amount)
    const taxes = useSelector((state)=>state.cart.taxes)
    //
    const cartData = useSelector((state)=> state.cart.cardData)
    const dispatch = useDispatch()
    const [isComplete , setIsComplete] = useState(false)
    const [imageIndex , setImageIndex] = useState(0)
    let home = useHistory()
    const onSubmitHandller = (e)=>{
        e.preventDefault()
        setIsComplete(true)  
        setTimeout(()=>{
            dispatch(shippingSliceActions.clearShipping())
            dispatch(cartSliceActions.claerCart())
            home.push('./')
        },3000)
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    const sliderHandller = (type)=>{
        if(type === 'increase'){
            setImageIndex(imageIndex+1)
            if(imageIndex >= cartData.length-1){
                setImageIndex(0)
            }
        }
        if(type === 'decrease'){
            setImageIndex(imageIndex-1)
            if(imageIndex <= 0){
                setImageIndex(cartData.length-1)
            }
        }
    }
    if(cartData === []){
            home.push('./products')
        }
    return (
        <section>
            <div className="container">
                {!isComplete && cartData !== [] && 
                    <div className="shipping_information">
                    {/* <div className="mask">
                        
                    </div>
                    <div className="mask2">
                        
                    </div> */}
                    <div className="shipping_details">
                        {/* cart preview */}
                        <div className="cart_preview_container">
                            <div className="products_image_preview">
                                <img src={cartData[imageIndex].image} alt="" />
                                <div className="slider_btn">
                                    <button className='left_btn' onClick={()=>sliderHandller('decrease')}>< FaArrowCircleLeft /></button>
                                    <button className='right_btn' onClick={()=>sliderHandller('increase')}><FaArrowCircleRight/></button>
                                </div>
                                <div className="item_preview_detail">
                                    <h3>{cartData[imageIndex].name}</h3>
                                    <span style={{backgroundColor:cartData[imageIndex].color}} className='item_color'></span>
                                </div>
                            </div>
                            <div className="mini_cart_preview">
                                <h4>cart items</h4>
                                <div className="mini_cart_items">
                                    {/* /////// */}
                                    {
                                        cartData.map((item)=>{
                                            return <Minicart key = {item.newId} {...item}/>
                                        })
                                    }
                                </div>
                            </div>
                            <div className="back_to_cart">
                                <Link to='/cart'>
                                    <button> <FaArrowCircleLeft className='back_to_cart_icon'/>back to cart</button>
                                </Link>
                            </div>
                        </div>
                        {/* //shipping details  */}
                        <form className='payment_details_form' onSubmit = {onSubmitHandller}>
                            <h4>Payment Details</h4>
                            <InputGroup type = 'text' infor = 'email adress' name='email' invalue={email}/>
                            <div className="input_group_container">
                                <InputGroup type = 'number' infor = 'card number' name='cardNumber' invalue={cardNumber}/>
                                <InputGroup type = 'text' infor = 'MM/YY' name='expire' invalue={expire}/>
                                <InputGroup type = 'number' infor = 'CCV' name='ccv' invalue={ccv}/>
                            </div>
                            <InputGroup type = 'text' infor = 'card holder name' name='cardHolderName' invalue={cardHolderName}/>
                            <div className="input_group_container">
                                <InputGroup type = 'text' infor = 'country' name='country' invalue={country}/>
                                <InputGroup type = 'text' infor = 'city' name='city' invalue={city}/>
                                <InputGroup type = 'number' infor = 'ZIP' name='postalCode' invalue={postalCode}/>
                            </div>
                            <InputGroup type = 'text' infor = 'address' name='adress' invalue={adress}/>
                            <div className="input_group_container_personal">
                                <InputGroup type = 'text' infor = 'first name' name='firstName' invalue={firstName}/>
                                <InputGroup type = 'text' infor = 'Last name' name='lastName' invalue={lastName}/>
                                <InputGroup type = 'text' infor = 'phone' name='phoneNumber' invalue={phoneNumber}/>
                            </div>
                            <div className="pill_details">
                                <div className="detail">
                                    <p>subtotal</p>
                                    <span>{currencyFormater(totalAmount)}</span>
                                </div>
                                <div className="detail">
                                    <p>tax</p>
                                    <span>{currencyFormater(taxes)}</span>
                                </div>
                                <div className="detail">
                                    <p>shipping</p>
                                    <span>{currencyFormater(shippingFee)}</span>
                                </div>
                            </div>
                            <div className="submit">
                                <button>Pay {currencyFormater(shippingFee + taxes + totalAmount)}</button>
                            </div>
                        </form>
                        </div>
                </div>
                }
                {
                    isComplete && <div className = 'thanks_for'>
                        <div>
                            <h4>thanks for buying from us </h4>
                            <p>redirecting to home page soon</p>
                        </div>
                    </div>
                }
            </div>
        </section>
    )
}

export default Payment
